import { Imovel } from '../types/Property';

// Cache para controlar logs duplicados
const loggedImoveis = new Set<string>();

/**
 * Ordena as mídias de um imóvel seguindo a lógica:
 * 1. Primeiro: mídias com is_capa = true
 * 2. Depois: demais mídias ordenadas pelo campo `ordem`
 * 3. Desconsidera mídias inativas
 */
export const getOrderedMidias = (imovel: Imovel, enableLogging = false) => {
  if (!imovel.midias || imovel.midias.length === 0) {
    return [];
  }

  // Filtrar apenas mídias ativas
  const activeMidias = imovel.midias.filter(m => m.ativa);

  // Separar capa das demais mídias
  const capa = activeMidias.find(m => m.is_capa);
  const outrasMidias = activeMidias.filter(m => !m.is_capa);

  // Ordenar as demais mídias pelo campo ordem
  const outrasOrdenadas = outrasMidias.sort((a, b) => {
    const ordemA = a.ordem || 999;
    const ordemB = b.ordem || 999;
    return ordemA - ordemB;
  });

  // Retornar capa primeiro, depois as demais ordenadas
  const resultado = capa ? [capa, ...outrasOrdenadas] : outrasOrdenadas;

  // Log do resultado da ordenação (executa apenas uma vez por imóvel se habilitado)
  if (enableLogging && resultado.length > 0 && !loggedImoveis.has(imovel.id)) {
    loggedImoveis.add(imovel.id);
    
    const info = {
      imovel_id: imovel.id.substring(0, 8),
      imovel_titulo: imovel.titulo.substring(0, 40),
      total_fotos: resultado.length,
      capa_definida: capa ? 'SIM' : 'NÃO',
      arquivo_capa: capa ? capa.url.substring(capa.url.lastIndexOf('/') + 1) : 'N/A',
      ordem_display: resultado.map((m, idx) => ({
        posicao: idx + 1,
        arquivo: m.url.substring(m.url.lastIndexOf('/') + 1),
        ordem_backend: m.ordem,
        is_capa: m.is_capa
      }))
    };
    
    // Mostrar no console de forma organizada
    console.log(`📸 ORDENAÇÃO - Imóvel: "${info.imovel_titulo}..."`, {
      total: info.total_fotos,
      capa: info.capa_definida,
      arquivo_capa: info.arquivo_capa,
      ordem: info.ordem_display
    });
  }

  return resultado;
};

/**
 * Retorna a primeira imagem (capa ou a primeira disponível)
 */
export const getFirstImage = (imovel: Imovel): string | null => {
  const orderedMidias = getOrderedMidias(imovel);
  
  // Filtrar apenas imagens
  const imagens = orderedMidias.filter(m => m.tipo === 'imagem');
  
  if (imagens.length > 0) {
    return imagens[0].url;
  }
  
  return null;
};

/**
 * Retorna todas as imagens ordenadas
 */
export const getOrderedImages = (imovel: Imovel, enableLogging = true) => {
  const orderedMidias = getOrderedMidias(imovel, enableLogging);
  return orderedMidias.filter(m => m.tipo === 'imagem');
};

